import { render, staticRenderFns } from "./ChoiceQuestionCheckboxes.vue?vue&type=template&id=15124940&scoped=true"
import script from "./ChoiceQuestionCheckboxes.vue?vue&type=script&lang=js"
export * from "./ChoiceQuestionCheckboxes.vue?vue&type=script&lang=js"
import style0 from "./ChoiceQuestionCheckboxes.vue?vue&type=style&index=0&id=15124940&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15124940",
  null
  
)

export default component.exports